export default "__VITE_ASSET__31cc6eb2__"